import React from "react";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import Spinner from "@components/common/Spinner";
import { ICalendario } from "src/@types/Home";
import { theme } from "src/styles/theme";
import { MdOutlineCall } from "react-icons/md";
import { BsSuitcaseLg } from "react-icons/bs";

type Props = {
  dataCalendar: ICalendario;
  loadingCalendar: boolean;
  onClick: (oportunidadeId: string, opportunityIdSalesforce: string) => void;
};

const CustomTasks = ({ dataCalendar, loadingCalendar, onClick }: Props) => {
  function handleType(type: string) {
    if (!type) return "";
    if (type?.toLowerCase()?.includes("task")) return "Tarefa";
    if (type?.toLowerCase()?.includes("call")) return "Chamada";
    return "";
  }

  function handleTypeIcon(type: string) {
    if (handleType(type) === "Tarefa")
      return <BsSuitcaseLg color={"#FFAA00"} fontSize={"22px"} />;
    if (handleType(type) === "Chamada")
      return <MdOutlineCall color={"#FFAA00"} fontSize={"24px"} />;
    return "";
  }
  return (
    <>
      <VStack
        overflowY={"auto"}
        h={{ base: "120px", sm: "120px", md: "130px" }}
        css={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#D3D3D3",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#A0AEC0",
          },
          "&::-webkit-scrollbar-track": {
            background: "#F7FAFC",
          },
        }}
      >
        {loadingCalendar ? (
          <Flex h={"110px"} align={"center"} justify={"center"}>
            <Spinner />
          </Flex>
        ) : (
          <>
            {dataCalendar?.tarefas?.length === 0 ? (
              <Flex align="center" justify="center" h={"110px"}>
                <Text
                  w={"fit-content"}
                  color={theme.text50}
                  textAlign="center"
                  fontSize={{ base: "xs", sm: "sm", md: "md" }}
                  px={2}
                >
                  Não há tarefas nas datas selecionadas!
                </Text>
              </Flex>
            ) : (
              <>
                {dataCalendar?.tarefas?.map(
                  (
                    {
                      nomeDaConta,
                      dataDeVencimento,
                      assunto,
                      comentarios,
                      tipoDeRegistro,
                      oportunidadeId,
                      opportunityIdSalesforce,
                    },
                    index
                  ) => (
                    <Flex
                      gap={{ base: 2, sm: 3, md: 4 }}
                      pb={3}
                      align={"center"}
                      key={index}
                      w="100%"
                    >
                      <Box
                        display={"flex"}
                        w={"fit-content"}
                        h={"30px"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        flexShrink={0}
                      >
                        {handleTypeIcon(tipoDeRegistro)}
                      </Box>

                      <Box
                        display={"flex"}
                        flexDir={"column"}
                        h={"fit-content"}
                        alignItems={{
                          base: "center",
                          sm: "flex-start",
                        }}
                        cursor={"pointer"}
                        onClick={() =>
                          onClick(oportunidadeId, opportunityIdSalesforce)
                        }
                        textAlign={"left"}
                      >
                        <Text
                          fontSize={{ base: "2xs", sm: "xs", md: "sm" }}
                          color={theme.text}
                          fontWeight={"bold"}
                        >
                          {assunto}
                        </Text>
                        <Text
                          fontSize={{
                            base: "3xs",
                            sm: "2xs",
                            md: "xs",
                          }}
                          color={theme.text}
                          noOfLines={2}
                        >
                          {dataDeVencimento}
                        </Text>
                        <Text
                          fontSize={{
                            base: "3xs",
                            sm: "2xs",
                            md: "xs",
                          }}
                          color={theme.text50}
                          noOfLines={3}
                        >
                          {nomeDaConta} | {comentarios}
                        </Text>
                      </Box>
                    </Flex>
                  )
                )}
              </>
            )}
          </>
        )}
      </VStack>
    </>
  );
};

export default CustomTasks;
